export const BUILD_VERSION = '1777473618';
